// Module
var code = "<div class=\"dms-outer-element container-fluid\" style=\"padding:0\">\n    <div class=\"dms-grid-wrapper dms-grid dms-easy-edit #=data.GridName#\">\n    </div>\n</div>";
// Exports
export default code;